import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFetch } from 'hooks/useFetch';
import { usePost } from 'hooks/usePost';
import styles from './Branding.module.scss';
import { useBrandingContext } from '../../../app-context/BrandingsContext';
import Tab from '../../../component/molecules/Tab/TabComponent';
import Header from 'component/layout/header/Header';
import Button from 'component/atom/forms/button/Button';
import LoginPageContent from './brandingComponents/LoginPageContent';
import MainPageContent from './brandingComponents/MainPageContent';
import * as Yup from 'yup';
import { settingsEndpoints } from 'hooks/endpoints';
import ResetCancelModal from 'component/hoc/modal/Modal';
import { Form, Formik } from 'formik';
import { consoleBrandingToast } from 'helpers/toastMessages';
import toast from 'react-hot-toast';

const validationSchema = Yup.object().shape({
  FirstField: Yup.number(),
  LoginBackgroundColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  LoginButtonColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  AddResetPassword: Yup.boolean(),
  AddSupport: Yup.boolean(),
  SideBar_BackgroundColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  SideBar_Active_BackgroundColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  SideBar_TextColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  SideBar_Active_TextColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  SideBar_Hover_BackgroundColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  SideBar_Hover_TextColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  Page_FontStyle: Yup.string(),
  Page_BackgroundColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  Page_TextColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
  Page_ButtonColor: Yup.string().matches(
    /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/,
    `Check Invalid Color`
  ),
});

function Branding({}) {
  const navigate = useNavigate();
  const formikRef = useRef();
  const [initialValues, setInitialValues] = useState({});

  const [bgURL, setBgURL] = useState(null);
  const [tempBGLogin, setTempBGLogin] = useState();

  const { data: branding, isFetching: isFetchingBranding } = useFetch(
    ['getBranding'],
    settingsEndpoints?.getBranding()
  );

  useEffect(() => {
    if (branding?.data) {
      setInitialValues({
        FirstField: branding?.data?.firstField || 0,
        LoginBackgroundColor: branding?.data?.loginBackgroundColor || '',
        LoginButtonColor: branding?.data?.loginButtonColor || '',
        AddResetPassword: branding?.data?.addResetPassword || false,
        AddSupport: branding?.data?.addSupport || false,
        SideBar_BackgroundColor: branding?.data?.sideBar_BackgroundColor || '',
        SideBar_Active_BackgroundColor:
          branding?.data?.sideBar_Active_BackgroundColor || '',
        SideBar_TextColor: branding?.data?.sideBar_TextColor || '',
        SideBar_Active_TextColor:
          branding?.data?.sideBar_Active_TextColor || '',
        SideBar_Hover_BackgroundColor:
          branding?.data?.sideBar_Hover_BackgroundColor || '',
        SideBar_Hover_TextColor: branding?.data?.sideBar_Hover_TextColor || '',
        SideBarLogo: branding?.data?.sideBarLogo || null,
        SideBarLogoContentType: branding?.data?.sideBarLogoContentType || '',

        LoginBackgroundImage: branding?.data?.loginBackgroundImage || null,
        LoginBackgroundImageContentType:
          branding?.data?.loginBackgroundImageContentType || '',

        MobileLogo: branding?.data?.mobileLogo || null,
        MobileLogoContentType: branding?.data?.mobileLogoContentType || '',

        Page_FontStyle: branding?.data?.page_FontStyle || '',
        Page_BackgroundColor: branding?.data?.page_BackgroundColor || '',
        Page_TextColor: branding?.data?.page_TextColor || '',
        Page_ButtonColor: branding?.data?.page_ButtonColor || '',
      });
    }
  }, [branding]);

  const { brandingData, isLoading, isError } = useBrandingContext();
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState('');
  const [pageTitle, setPageTitle] = useState('Login');
  const [isSubmitAttempted, setIsSubmitAttempted] = useState(false);

  //---------------------------------------------------------
  const handleUploadChange = (event, setFieldValue) => {
    const file = event.target.files[0];
    if (file && event.target.name === 'bgImage') {
      setTempBGLogin(file);
      setFieldValue('LoginBackgroundImage', file);
    }
    if (file && event.target.name === 'sideBarLogo') {
      setFieldValue('SideBarLogo', file);
    }
    if (file && event.target.name === 'mobileLogoView') {
      setFieldValue('MobileLogo', file);
    }
  };

  const handleOnClick = (fields) => {
    const formData = new FormData();
    for (const key in fields) {
      formData.append(key, fields[key]);
    }
    AddBranding(formData);
  };

  const { mutate: Branding } = usePost({
    onErrorToast: 'Error occur',
    onSuccessToast: consoleBrandingToast.save,
    toastType: 'add',
  });
  const AddBranding = (form) => {
    Branding(
      {
        url: settingsEndpoints?.setCompanyBranding(),
        data: form,
        isFormData: true,
      },
      {
        onSuccess: () => {
          window.location.reload();
        },
      }
    );
  };

  const handleCancel = (resetForm) => {
    resetForm({ values: initialValues });
    setShowModal(false);
  };

  const handleReset = (resetForm) => {
    resetForm({
      values: {
        FirstField: '',
        LoginBackgroundColor: '#F3F8FD',
        LoginButtonColor: '#0844E1',
        AddResetPassword: false,
        AddSupport: false,
        SideBar_BackgroundColor: '#020a58',
        SideBar_Active_BackgroundColor: '#040e67',
        SideBar_TextColor: '#fff',
        SideBar_Active_TextColor: '#fff',
        SideBar_Hover_BackgroundColor: '#040e67',
        SideBar_Hover_TextColor: '#fff',
        Page_FontStyle: '',
        Page_BackgroundColor: '#F3F8FD',
        Page_TextColor: '#000000',
        Page_ButtonColor: '#0844E1',
        SideBarLogo: null,
        SideBarLogoContentType: null,
        MobileLogo: null,
        MobileLogoContentType: null,
        LoginBackgroundImage: null,
        LoginBackgroundImageContentType: '',
        SideBarLogo_Delete: true,
        MobileLogo_Delete: true,
        LoginBackground_Delete: true,
      },
    });

    setShowModal(false);
  };
  useEffect(() => {
    if (
      isSubmitAttempted &&
      Object.keys(formikRef?.current?.errors).length > 0
    ) {
      toast.error('Check Invalid Color');
    }
    setTimeout(() => {
      setIsSubmitAttempted(false);
    }, 500);
  }, [formikRef?.current?.errors, isSubmitAttempted]);

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={(values) => {
        setIsSubmitAttempted(false);
        handleOnClick(values);
      }}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        errors,
        touched,
        handleSubmit,
      }) => {
        const tabs = [
          {
            label: 'Login',
            content: (
              <LoginPageContent
                values={values}
                setFieldValue={setFieldValue}
                tempBGLogin={tempBGLogin}
                setTempBGLogin={setTempBGLogin}
                bgURL={bgURL}
                setBgURL={setBgURL}
                branding_BackgroundColor={true}
                handleUploadChange={(event) =>
                  handleUploadChange(event, setFieldValue)
                }
                errors={errors}
                touched={touched}
              />
            ),
            branding_BackgroundColor: true,
          },
          {
            label: 'Main Page',
            content: (
              <MainPageContent
                values={values}
                setFieldValue={setFieldValue}
                handleUploadChange={(event) =>
                  handleUploadChange(event, setFieldValue)
                }
                errors={errors}
                touched={touched}
              />
            ),
            branding_BackgroundColor: false,
          },
        ];
        return (
          <Form>
            <div
              className="container-fluid"
              style={{
                backgroundColor: brandingData?.page_BackgroundColor,
                minHeight: '100vh',
              }}
            >
              <div className={styles.btnCont}>
                <Header title="Branding" />
                <div className={styles.right}>
                  <Button
                    label={'Cancel'}
                    variant={'#C81111'}
                    transparent
                    width={'15%'}
                    onClick={() => {
                      setModalText('cancel');
                      setShowModal(true);
                    }}
                  />{' '}
                  <Button
                    label={'Reset'}
                    transparent
                    width={'8%'}
                    onClick={() => {
                      setModalText('reset');
                      setShowModal(true);
                    }}
                  />
                  <Button
                    label={'Save'}
                    type="save"
                    onClick={() => {
                      setIsSubmitAttempted(true);
                      handleSubmit();
                    }}
                    width={'18%'}
                  />
                </div>
              </div>

              <div className={styles['tabs-wrapper']}>
                <Tab tabs={tabs} setPageTitle={setPageTitle} />
              </div>

              <ResetCancelModal
                title={`${modalText} Branding`}
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                showCancel={false}
                modalContent={{
                  component: (
                    <span>
                      Are you sure you want to {modalText} the branding?
                    </span>
                  ),
                }}
                onSubmit={() =>
                  modalText === 'reset'
                    ? handleReset(resetForm)
                    : handleCancel(resetForm)
                }
                buttonType="submit"
                onSubmitstyles={{
                  onSubmit: {
                    label: modalText,
                    opicBAckground: true,
                  },
                }}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default Branding;
